<template>
  <spinner class="mask-spinner" height="100%" />
</template>
<script>
import Spinner from './Spinner.vue'
export default {
  components: {
    Spinner
  }
}
</script>
<style scoped>
.mask-spinner {
  position: absolute;
  width: 100%;
  top: 0;
  left: 0;
  background-color: #bbb;
  opacity: 0.5;

  :deep(.spinner) {
    color: black;
  }
}
</style>
